export enum LogoutTrigger {
    USER = 'user',
    TIMEOUT = 'timeout',
    BROADCAST = 'broadcast',
}
